import { useEffect } from "react";

/** Llave de sessionStorage con la operación que hay que abrir al llegar a una cola */
const LLAVE = "finalizaAbrir";

/**
 * Pide que, al llegar a la cola de ese proceso, se abra una operación para gestionarla. Lo usa el Tablero de
 * Finalización: el número de la operación lleva a la cola de su subetapa con la operación ya abierta, en vez de al
 * Tracking de Importaciones (root/gestionsiaco#429).
 * @param {string} cProceso PRODURLX de la cola (Entregat, Entregad, Infoadic)
 * @param {string} cDocnroxx Número de la operación
 */
export const pedirAbrir = (cProceso, cDocnroxx) => {
  try { window.sessionStorage.setItem(LLAVE, JSON.stringify({ proceso: cProceso, docnroxx: String(cDocnroxx) })); } catch (e) { /* sin almacenamiento */ }
};

/**
 * Si al llegar a esta cola hay una operación pedida, la abre en cuanto la cola la trae y borra el pedido.
 * @author Claude <root/gestionsiaco#429>
 * @since 2026-10-13
 * @param {string} cProceso PRODURLX de esta cola
 * @param {Array} filas Filas que trajo la cola
 * @param {function} onAbrir Abre la fila (la hoja del DO o el panel de la cola)
 */
export const useAutoabre = (cProceso, filas, onAbrir) => {
  useEffect(() => {
    let pedido = null;
    try { pedido = JSON.parse(window.sessionStorage.getItem(LLAVE) || "null"); } catch (e) { pedido = null; }
    if (!pedido || pedido.proceso !== cProceso || filas.length === 0) {
      return;
    }
    const fila = filas.find((mFila) => String(mFila.DOCNROXX) === pedido.docnroxx);
    if (fila) {
      try { window.sessionStorage.removeItem(LLAVE); } catch (e) { /* sin almacenamiento */ }
      onAbrir(fila);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cProceso, filas]);
};

export default useAutoabre;
